import React from "react";
import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
import { useBottomSheet } from "../../../../../contexts/bottomSheet/bottomSheet.context";
import { useTranslations } from "../../../../../contexts/translations/translations.context";
import { DA_MiniSearch } from "../../MiniSearch/MiniSearch.component";
import { useSiteHeader } from "../../../../../contexts/siteHeader.context";
import { DA_MiniSearchB2c } from "../../MiniSearchB2c/MiniSearchB2c.component";
import { DA_MiniSearchB2bStyle } from "../../MiniSearchB2bStyle/MiniSearchB2bStyle.component";

export const useSearchButton = () => {
    const { getDictionaryString } = useTranslations();
    const { closeMobileNav, showMobileNav } = useSiteHeader();
    const { currentSite } = useAppData();

    const { presentBottomSheet, dismissBottomSheet, activeBottomSheet } = useBottomSheet();

    const b2cSite = currentSite === "B2C";
    const useB2bStyleSearch =
        globalThis.searchPageVersion === "v1" &&
        (currentSite === "B2B" || currentSite === "MYFARM");

    const onSearchButtonClicked = () => {
        const id = "search";

        if (activeBottomSheet !== id) {
            let searchComponent;
            if (b2cSite) {
                searchComponent = <DA_MiniSearchB2c />;
            } else if (useB2bStyleSearch) {
                searchComponent = <DA_MiniSearchB2bStyle />;
            } else {
                searchComponent = <DA_MiniSearch />;
            }

            presentBottomSheet(searchComponent, {
                id: id,
                headerTitle: getDictionaryString("searchModalTitle"),
            });
            // Close mobileNav after bottomSheet has opened
            if (showMobileNav) {
                setTimeout(() => {
                    closeMobileNav();
                }, 500);
            }
        } else {
            dismissBottomSheet();
        }
    };

    return {
        showSearch: true,
        onSearchButtonClicked,
        isSearchMenuActive: false,
    };
};
